import React, { useState, useEffect } from "react";
import * as api from "./../../api/api";
import Payment from "./../payment/payment";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const inititalFormData = {
  sponsor_id: "",
  subscription_id: localStorage.getItem("id"),
};

export default function Subscriptions(props) {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState(inititalFormData);
  const [subscription, setSubscription] = useState("");
  const [payment, setPayment] = useState(false);
  const [data, setData] = useState("");
  const [subId, setSubId] = useState([]);
  console.log(props.id);
  useEffect(() => {
    subscriptionApi();
  }, []);

  const subscriptionApi = async () => {
    const response = await api.subscription();

    console.log("response", response);
    if (response) {
      response.data.map((item, index) => setSubId(item.id));
      console.log("response", response);
      setSubscription(response.data);
      setLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target.value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    // console.log("props.id", formData.sponsor_id);
    // return false;
    if (formData.sponsor_id) {
      // setFormData({
      //   ...formData,
      //   subscription_id: formData.sponsor_id,
      // });
      try {
        const reqObj = {
          subscription_id: formData.sponsor_id,
          sponsor_id: props.id,
        };
        console.log("reqObj", reqObj);

        const response = await api.payment(reqObj);
        console.log("response", response);
        if (response) {
          setData(response);
          setPayment(true);
        }
      } catch (e) {}
    }
  };

  return (
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                {!payment ? (
                  <>
                    <h4 className="card-title">Subscriptions</h4>
                    <p className="card-description"> Select your plan </p>
                    <form className="forms-sample pb-3">
                      <div className="row pl-3">
                        <div className="form-check p-0">
                          <label className="form-check-label ml-2">
                            {Object.keys(subscription).map((index, key) => {
                              //console.log(subscription[index].id);
                              return (
                                <>
                                  <div className="col-lg-12 mb-2">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      name="sponsor_id"
                                      id="membershipRadios1"
                                      value={subscription[index].id}
                                      onChange={handleChange}
                                      key={key}
                                    />
                                    {subscription[index].plan_name} - Total
                                    Post: {subscription[index].total_post} -
                                    Price: $ {subscription[index].price}
                                    <i className="input-helper"></i>
                                  </div>
                                </>
                              );
                            })}
                          </label>
                        </div>
                      </div>
                    </form>
                    <button
                      onClick={handleSubmit}
                      className="btn btn-gradient-primary mr-2"
                      style={{ color: "white" }}
                    >
                      Buy
                    </button>
                  </>
                ) : (
                  <Payment data={data} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
